<template>
  <div>
    <div :class="styles">
      <label>{{ label }}<span class="has-text-danger">*</span></label>

      <ValidationProvider
        :rules="validationRules"
        v-slot="{ errors }"
        :name="fieldName"
      >
        <div class="columns" style="flex-wrap: wrap; align-items: baseline">
          <div
            :class="itemList"
            v-for="(item, index) in radioOptions"
            :key="`${index}${item.langTranslation}`"
          >
            <b-field>
              <b-radio
                :name="name"
                :native-value="item.value"
                v-model="vModelVaribale"
              >
                {{ item.langTranslation }}
              </b-radio>
            </b-field>
          </div>
        </div>

        <span class="has-text-danger">{{ errors[0] }}</span>
      </ValidationProvider>
    </div>
  </div>
</template>
<script>
export default {
  name: "RadioButtonField",

  props: [
    "label",
    "value",
    "radioOptions",
    "styles",
    "validationRules",
    "name",
    "inputFunc",
    "disabled",
    "itemList",
    "fieldName",
  ],

  components: {},
  data() {
    return {
      errorFromProvider: "",
    };
  },
  methods: {
    sendError(error) {
      this.$emit(`getError`, error);
    },
  },
  computed: {
    vModelVaribale: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>
<style></style>
